// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sunflora: PokeData = {
  "id": 192,
  "name": "sunflora",
  "height": 8,
  "weight": 85,
  "base_experience": 149,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "pound",
    "tackle",
    "double-edge",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "razor-leaf",
    "solar-beam",
    "petal-dance",
    "giga-drain",
    "synthesis",
    "sunny-day",
    "ingrain",
    "endeavor",
    "grass-whistle",
    "bullet-seed",
    "natural-gift",
    "worry-seed",
    "seed-bomb",
    "leaf-storm",
    "petal-blizzard",
    "flower-shield"
  ],
  "moves": [
    "tackle",
    "razor-leaf",
    "solar-beam",
    "synthesis",
    "sunny-day",
    "bullet-seed",
    "vine-whip",
    "power-whip",
    "frenzy-plant",
    "energy-ball",
    "wood-hammer",
    "flower-rush",
    "aromatherapy"
  ],
  "evolution_chain": {
    "id": 94,
    "item": null,
    "species": [
      {
        "name": "sunkern",
        "order": 221,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sunflora",
        "order": 222,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 191,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 140,
    "speed": 58,
    "ability_power": 202
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
